import {getMethod, postMethod, putMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/restrictedLocations', request)
}

async function post(request) {
    return await postMethod('/api/restrictedLocations', request)
}

async function put(request) {
    return await putMethod('/api/restrictedLocations', request)
}

export {get, post, put}
